export default __webpack_public_path__ + "static/media/media_card_placeholder.69ffea4f.jpg";